export var DateShowtimePickerActionType;
(function (DateShowtimePickerActionType) {
    DateShowtimePickerActionType["Loading"] = "Loading";
    DateShowtimePickerActionType["FailedToLoad"] = "FailedToLoad";
    DateShowtimePickerActionType["Loaded"] = "Loaded";
    DateShowtimePickerActionType["LoadingAllFilms"] = "LoadingAllFilms";
    DateShowtimePickerActionType["LoadedAllFilms"] = "LoadedAllFilms";
    DateShowtimePickerActionType["FailedToLoadAllFilms"] = "FailedToLoadAllFilms";
    DateShowtimePickerActionType["SetOldShowtimeIdsForDate"] = "SetOldShowtimeIdsForDate";
    DateShowtimePickerActionType["SelectDate"] = "SelectDate";
    DateShowtimePickerActionType["SetIsExternalDateTransition"] = "SetIsExternalDateTransition";
    DateShowtimePickerActionType["ToggleAllFilms"] = "ToggleAllFilms";
})(DateShowtimePickerActionType || (DateShowtimePickerActionType = {}));
